import type { CapitalGlobalProposalStepProps } from '@/features/proposals/components/capital-global/capital-global-proposal-step.types';
import { CapitalGlobalProposalAssinaturaFooter } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-assinatura-footer.component';
import { CapitalGlobalProposalAssinaturaImportSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-assinatura-import-section.component';
import { CapitalGlobalProposalResumePremiumSection } from '@/features/proposals/components/capital-global/steps/sections/capital-global-proposal-resume-premium-section.component';
import { useCapitalGlobalProposalStep4ViewModel } from '@/features/proposals/hooks/capital-global/use-capital-global-proposal-step4-view-model.hook';
import { Spinner } from '@noorden-insurtech/alba-design-system';

export function StepCapitalGlobalAssinatura(
  props: CapitalGlobalProposalStepProps
) {
  const {
    premiumData,
    isHydrating,
    slots,
    attachmentsByType,
    uploadingDocumentType,
    deletingAttachmentId,
    showSignedProposalRequiredError,
    isUploadEnabled,
    isPhysicalUploadPending,
    handleFileSelect,
    handleRemove,
    handleDownload,
    handleExit,
  } = useCapitalGlobalProposalStep4ViewModel({
    proposal: props.proposal,
    policyId: props.policyId,
    isViewMode: props.isViewMode,
  });

  if (isHydrating) {
    return (
      <div className='flex items-center justify-center py-16'>
        <Spinner size='lg' colorScheme='blue' />
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-10'>
      <CapitalGlobalProposalResumePremiumSection data={premiumData} />

      <CapitalGlobalProposalAssinaturaImportSection
        slots={slots}
        attachmentsByType={attachmentsByType}
        isViewMode={!isUploadEnabled}
        uploadingDocumentType={uploadingDocumentType}
        deletingAttachmentId={deletingAttachmentId}
        showSignedProposalRequiredError={showSignedProposalRequiredError}
        onFileSelect={(documentType, file) => {
          void handleFileSelect(documentType, file);
        }}
        onRemove={attachment => {
          void handleRemove(attachment);
        }}
        onDownload={handleDownload}
      />

      <CapitalGlobalProposalAssinaturaFooter
        isViewMode={props.isViewMode && !isPhysicalUploadPending}
        canGoBack={props.canGoBack}
        onBack={props.onBack}
        onExit={handleExit}
      />
    </div>
  );
}
